import { Box, BoxProps, Heading, Paragraph } from "../atoms";
import {
  PropertyCardWrapper,
  PropertyCardContent,
  PropertyGrid,
} from "../molecules";
import { Property } from "types";
import { clampFontSize } from "utils";
import { motion, Variants } from "framer-motion";

const MainPropertiesHeader: React.FC<BoxProps & { description?: string }> = ({
  css,
  children,
  description,
  ...props
}) => {
  return (
    <Box css={{ textAlign: "center", marginBottom: "$4", ...css }} {...props}>
      <Heading>{children}</Heading>
      {description && (
        <Paragraph
          css={{
            fontSize: clampFontSize("$3", "$6", 0.3),
            "@bp3": { fontSize: "$6", fontWeight: "$semibold" },
          }}
        >
          {description}
        </Paragraph>
      )}
    </Box>
  );
};

type Props = { properties: Property[] };

const MotionGrid = motion(PropertyGrid);
const MotionCard = motion(PropertyCardWrapper);

const container: Variants = {
  show: {
    transition: {
      staggerChildren: 1,
    },
  },
};

const item: Variants = {
  hidden: { y: 50, opacity: 0 },
  show: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", duration: 1 },
  },
};

const propertiesNotFound = "No se encontraron resultados para tu búsqueda";

const MainPropertiesList: React.FC<Props> = ({ properties }) => {
  return (
    <MotionGrid variants={container} initial="hidden">
      {properties.length > 0
        ? properties.map((property, index) => (
            <MotionCard
              key={property.id}
              whileInView="show"
              variants={item}
              viewport={{ once: true, amount: 0.3 }}
            >
              <PropertyCardContent property={property} priority={index === 0} />
            </MotionCard>
          ))
        : propertiesNotFound}
    </MotionGrid>
  );
};

const PropertyList: React.FC<Props> = ({ properties }) => {
  return (
    <PropertyGrid>
      {properties.length > 0
        ? properties.map((property, index) => (
            <PropertyCardWrapper key={property.id}>
              <PropertyCardContent property={property} priority={index === 0} />
            </PropertyCardWrapper>
          ))
        : propertiesNotFound}
    </PropertyGrid>
  );
};

export { MainPropertiesHeader, MainPropertiesList, PropertyList };
